import {
  collection,
  addDoc,
  doc,
  getDocs,
  query,
  orderBy,
  updateDoc,
  serverTimestamp,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

export interface Feedback {
  id?: string;
  text: string;
  is_voice: boolean;
  summary?: string;
  user_id: string;
  user_name: string;
  screen_name?: string;
  has_form_data?: boolean;
  created_at: Timestamp;
  status: 'new' | 'read' | 'reviewed';
  updated_by?: string;
  updated_at?: Timestamp;
}

export async function submitFeedback(data: {
  text: string;
  is_voice: boolean;
  user_id: string;
  user_name: string;
  screen_name?: string;
  has_form_data?: boolean;
}): Promise<string> {
  const docRef = await addDoc(collection(db, 'feedback'), {
    ...data,
    status: 'new',
    created_at: serverTimestamp(),
  });
  return docRef.id;
}

export async function getAllFeedback(): Promise<Feedback[]> {
  const q = query(
    collection(db, 'feedback'),
    orderBy('created_at', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() } as Feedback));
}

export async function updateFeedbackStatus(
  feedbackId: string,
  status: 'new' | 'read' | 'reviewed',
  userId: string
): Promise<void> {
  const ref = doc(db, 'feedback', feedbackId);
  await updateDoc(ref, {
    status,
    updated_by: userId,
    updated_at: serverTimestamp(),
  });
}
